import api from "../../utils/axios";
import { BULK_ORDER_OPERATIONS_ENDPOINTS } from "./endpoints";
import { BulkOrderOperationRequest, BulkOrderOperationResponse } from "./types";

export const executeBulkOrderOperation = async (
	body: BulkOrderOperationRequest
): Promise<BulkOrderOperationResponse> => {
	const response = await api.post<BulkOrderOperationResponse>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.execute,
		body
	);
	return response.data;
};
